<wms-dialog-header title="{{locale[dialogCaption]}}" (onClose)="closeModal()"></wms-dialog-header>
<wms-dialog-body>
    <wms-message [scopeDataset]="fileAddMessage"></wms-message>
    <div>
        <p class="col-md-5 control-label" [innerHTML]="dialogContent"></p>
        <div class="col-md-7">
            <input class="new-page-name form-control" [maxlength]="pageNameLimit"
                [autofocus]="true" [(ngModel)]="pageName" placeholder="{{locale.LABEL_CONFIRM_RENAME_PAGE_PLACEHOLDER}}"
                (keypress)="initiateRenameOrDuplicate($event)" />
        </div>
        <div class="refresh-warn-message">
            <wms-message *ngIf="dialogAction === 'RENAME'" [scopeDataset]="renameMessage"
                hideclose="true"></wms-message>
        </div>
    </div>
</wms-dialog-body>
<wms-dialog-footer>
    <button class="button-secondary btn app-button" title="{{locale.LABEL_CANCEL}}" (click)="closeModal()"><span
            class="btn-caption">{{locale.LABEL_CANCEL}}</span></button>
    <button class="button-primary btn app-button" title="{{locale.LABEL_SAVE}}" (click)="renameDuplicatePage()"
        [disabled]="dialogAction !== 'DUPLICATE' && oldPageName === pageName || pageName === ''"><span
            class="btn-caption">{{locale.LABEL_SAVE}}</span></button>
</wms-dialog-footer>